



































































































import { Component, Mixins } from 'vue-mixin-decorator';
import { Prop } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import { DownloadFileMixin } from '@/mixins/DownloadFileMixin';
import Http from '@/Http';
import { namespace } from 'vuex-class';
import { Position } from '@/types/work/enterprise';
import { NAMESPACE } from '@/store/models/work/enterprise/positions';
import { GET_ITEMS } from '@/store';

const positionsStore = namespace(NAMESPACE);

@Component({
  components: { Dialog }
})
export default class CustomersReport extends Mixins<DownloadFileMixin>(DownloadFileMixin) {
  @Prop() showDialog: boolean = false;

  @positionsStore.Getter(GET_ITEMS) posts!:any[];

  public filters = {
    manager_id: undefined,
    show_invoices: 0,
    invoices: {
      per_date: [
        {
          field: 'created_at',
          from: '',
          to: ''
        }
      ]
    }
  };

  from = false;
  to = false;

  loading = false;

  public generateReport () {
    this.loading = true;
    (new Http()).arrayBuffer({
      url: `enterprise/${this.$route.params.enterprise}/customers/report`,
      params: {
        filters: {
          ...this.filters
        }
      }
    })
      .then((response:any) => {
        this.downloadFile(response);
        this.loading = false;
        this.$emit('close');
      })
      .catch((e:any) => {
        this.loading = false;
      });
  }
}
